import axios from 'axios';
import { getToken, triggerLogout } from './auth';

const API_URL = process.env.REACT_APP_SERVER_DOMAIN;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use(async (config) => {
  try {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

// Handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common error scenarios
    if (error.response) {
      // Server responded with a status code outside of 2xx range
      if (error.response.status === 401) {
        // Session expired or unauthorized - log out the user
        console.error('Session expired. Logging out...');
        triggerLogout();
      } else if (error.response.status === 403) {
        // Handle forbidden error
        console.error('You do not have permission to access this resource.');
      } else if (error.response.status === 500) {
        // Handle server error
        console.error('Server error occurred. Please try again later.');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received from server. Please check your connection.');
    } else {
      // Something happened in setting up the request
      console.error('Error in request setup:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;